import LegalLayout from "@/components/LegalLayout";

export default function Impressum() {
    return (
        <LegalLayout title="Impressum" eyebrow="Angaben gemäß § 5 TMG">
            <section>
                <h2>Anbieter</h2>
                <p>
                    Stickerbag<br />
                    In der Straße der Jugend 18<br />
                    14974 Ludwigsfelde<br />
                    Deutschland
                </p>
            </section>

            <section>
                <h2>Vertreten durch</h2>
                <p>Isabell Helmund (Inhaberin)</p>
            </section>

            <section>
                <h2>Kontakt</h2>
                <p>
                    Telefon: +49 176 82337092<br />
                    E-Mail: <a href="mailto:lunarislp@gmx.de">lunarislp@gmx.de</a>
                </p>
            </section>

            <section>
                <h2>Umsatzsteuer</h2>
                <p>
                    Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer
                    berechnet und auf Rechnungen nicht ausgewiesen.
                </p>
            </section>

            <section>
                <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                <p>
                    Isabell Helmund<br />
                    In der Straße der Jugend 18<br />
                    14974 Ludwigsfelde
                </p>
            </section>

            <section>
                <h2>Online-Streitbeilegung</h2>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streit­beilegung (OS) bereit:{" "}
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                        https://ec.europa.eu/consumers/odr
                    </a>
                    .
                </p>
                <p>
                    Wir sind nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren
                    vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </section>

            <section>
                <h2>Haftung für Inhalte und Links</h2>
                <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
                    verantwortlich. Für verlinkte fremde Inhalte übernehmen wir keine Gewähr.
                </p>
            </section>

            <p className="text-xs text-[#64748b] pt-8 border-t border-white/10">
                Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
            </p>
        </LegalLayout>
    );
}
